// extracted by mini-css-extract-plugin
module.exports = {"devDeetsModal":"B89+chNQkvP0B0ONrlGaVA=="};